import { COLORS } from '@styles/colors'
import { useInView } from 'react-intersection-observer'
import * as S from './StackedBarChart.styled'

const StackedBarColors = [
  COLORS.cobalt.base,
  COLORS.cobalt[70],
  COLORS.cobalt[40],
]

const StackedBarChart = ({ data, title, note, alwaysShowTitle }) => {
  const [ref, inView] = useInView({
    threshold: 0.1,
    triggerOnce: true,
  })

  if ((!data || data.length === 0) && !alwaysShowTitle) return null

  return (
    <S.StackedBarChart ref={ref}>
      {title && <S.StackedBarChartTitle>{title}</S.StackedBarChartTitle>}
      {inView && data.length > 0 ? (
        <S.BarWrapper>
          {data.map((item, key) => (
            <S.BarSegment
              key={item.label}
              width={item.value}
              color={item.color || StackedBarColors[key]}
            >
              <span>{item.value}%</span>
            </S.BarSegment>
          ))}
        </S.BarWrapper>
      ) : null}

      {data.length > 0 ? (
        <S.Legend>
          {data.map((item, key) => (
            <S.LegendItem key={item.label}>
              <S.Dot color={item.color || StackedBarColors[key]} />
              {item.label} {item.value}%
            </S.LegendItem>
          ))}
          <S.LegendItem>{note}</S.LegendItem>
        </S.Legend>
      ) : null}
    </S.StackedBarChart>
  )
}

export default StackedBarChart
